import Accordion from '01_core/components/layout/Accordion';
import CLink from '01_core/components/materials/CLink';
import ResourceHtml from '01_core/components/materials/ResourceHtml';
import { withCallAPI } from '01_core/components/system/CallAPI';
import { withCodeUtil } from '01_core/components/system/CodeUtil';
import { withRouter } from '01_core/components/system/CustomRouter';
import { HOME_USER_INFO, STATUS } from '01_core/constants/APIs';
import { CODE } from '01_core/constants/CodeConsts';
import { LABEL } from '01_core/constants/labelConsts';

import QRCode from 'qrcode.react';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { documentLinkActions } from '../../common/documentLink';
import { menuLinkActions } from '../../common/systemLink';

import { HOME_DATA_KEY, TYPES, homeActions } from '../homeActions';
import appStoreBadge from '../images/app-store-badge.svg';
import googlePlayBadge from '../images/google-play-badge.png';
import { styles } from '../styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledSafetyButtonText = styled(Typography)(({ theme }) => stylesFromTheme(theme).safetyButtonText || {});
const StyledSafetyButtonTextResourceHtml = styled(ResourceHtml)(({ theme }) => stylesFromTheme(theme).safetyButtonText || {});
const StyledSafetyButtonNoUserInfoText = styled(Typography)(({ theme }) => stylesFromTheme(theme).safetyButtonNoUserInfoText || {});
const StyledSafetyButton = styled(Button)(({ theme }) => stylesFromTheme(theme).safetyButton || {});
const StyledSafetyInfoOverview = styled(ResourceHtml)(({ theme }) => stylesFromTheme(theme).safetyInfoOverview || {});
const StyledDowloadArea = styled(QRCode)(({ theme }) => stylesFromTheme(theme).downloadArea || {});
const StyledDownloadBadge = styled('img')(({ theme }) => stylesFromTheme(theme).downloadBadge || {});

export class SafetyInfoField extends React.Component {
  constructor(props) {
    super(props);

    const { callAPI, setHomeData } = props;
    callAPI(HOME_USER_INFO).then((response) => {
      if (response.status === STATUS.SUCCESS) {
        setHomeData(HOME_DATA_KEY.USER_INFO_DATA, response);
      }
    });
  }
  
  onPersonalRegister = () => {
    this.props.history.push('/usercustom_personal_register');
  };
  
  createIPhoneQRValue = () => {
    const value=this.props.systemSettings.bizappdl_app_store_url;
    return value;
  };
  
  createAndroidQRValue = () => {
    const value=this.props.systemSettings.bizappdl_google_play_url;
    return value;
  };
  
  render() {
    const { intl, userInfo, loginUserInfo, loginUserAuth, systemLink, documentLink, getCodeName, callAPIRawResponse, openInfoBar } = this.props;

    let onClickSafetyRegisterCriteriaPdf ;
    try {
      onClickSafetyRegisterCriteriaPdf = documentLinkActions['documentlink_safety_criteria'](callAPIRawResponse, documentLink, openInfoBar, intl);
    } catch (e) {
      onClickSafetyRegisterCriteriaPdf = () => {};
    }
    
    let onClickSafetyConfirmationExternalLink;
    try {
      onClickSafetyConfirmationExternalLink = menuLinkActions['systemlink_biz_anpi']('', loginUserInfo , systemLink);
    } catch (e) {
      onClickSafetyConfirmationExternalLink = () => {};
    }

    let workTdfkName = userInfo.workTdfkCd
      ? getCodeName(CODE.TDFK.KBN, userInfo.workTdfkCd)
      : null;

    let personalRegisterLabel = (!userInfo || !workTdfkName || !userInfo.mailAddress1) ? (
      <div>
        <StyledSafetyButtonText>
          {intl.formatMessage({ id: LABEL.COMMON_SAFETY_SETTING_PERSONAL })}
        </StyledSafetyButtonText>
        <StyledSafetyButtonNoUserInfoText>
          <b>
            {intl.formatMessage({ id: LABEL.COMMON_SAFETY_NOT_SETTING })}
          </b>
        </StyledSafetyButtonNoUserInfoText>
      </div>
    ) : (
      <StyledSafetyButtonText>
        {intl.formatMessage({ id: LABEL.COMMON_SAFETY_SETTING_PERSONAL })}
      </StyledSafetyButtonText>
    );
    
    return (
      <Accordion
        title={intl.formatMessage({ id: LABEL.COMMON_SAFETY_TITLE })}
      >
        <Grid container>
          { loginUserAuth.authFlg === 0 ? (
            <Grid size={{ xs: 4 }}>
              <StyledSafetyButton
                variant='contained'
                onClick={this.onPersonalRegister}
              >
                <React.Fragment>{personalRegisterLabel}</React.Fragment>
              </StyledSafetyButton>
            </Grid>
          ) : null }
          <Grid size={{ xs: 4 }}>
            <StyledSafetyButton
              variant='contained'
              onClick={onClickSafetyRegisterCriteriaPdf}
            >
              <StyledSafetyButtonTextResourceHtml
                id={LABEL.COMMON_SAFETY_REGISTER_CRITERIA_PDF} />
            </StyledSafetyButton>
          </Grid>
          <Grid size={{ xs: 4 }}>
            <StyledSafetyButton
              variant='contained'
              onClick={onClickSafetyConfirmationExternalLink}
            >
              <StyledSafetyButtonTextResourceHtml
                id={LABEL.COMMON_SAFETY_CONFIRMATION_EXTERNAL_LINK} />
            </StyledSafetyButton>
          </Grid>
        </Grid>
        <br/>
        <StyledSafetyInfoOverview id={LABEL.COMMON_SAFETY_OVERVIEW} />
        <br/>
        <StyledSafetyInfoOverview id={LABEL.COMMON_BIZ_MAIL_INFO} />
        <br/>
        <ResourceHtml id={LABEL.COMMON_SAFETY_APP_INSTALL} />
        <br/>
        <Grid container style={{marginLeft: '1rem' }}>
          <Grid size={{ xs: 6 }}>
            <Typography>
              {intl.formatMessage({ id: LABEL.COMMON_SAFETY_IPHONE_MESSAGE })}
            </Typography>
            <Grid container alignItems="flex-end">
              <Grid>
                <StyledDowloadArea value={this.createIPhoneQRValue()} />
              </Grid>
              <Grid>
                <CLink
                  href={this.createIPhoneQRValue()}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <StyledDownloadBadge src={appStoreBadge} alt="App Store" />
                </CLink>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography>
              {intl.formatMessage({ id: LABEL.COMMON_SAFETY_ANDROID_MESSAGE })}
            </Typography>
            <Grid container alignItems="flex-end">
              <Grid>
                <StyledDowloadArea value={this.createAndroidQRValue()} />
              </Grid>
              <Grid>
                <CLink
                  href={this.createAndroidQRValue()}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <StyledDownloadBadge src={googlePlayBadge} alt="Google Play" />
                </CLink>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.home.homeData[HOME_DATA_KEY.USER_INFO_DATA]
      ? state.home.homeData[HOME_DATA_KEY.USER_INFO_DATA]
      : {},
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    loginUserAuth: state.coreLoginInfo.loginUser.loginUserAuth,
    systemSettings: state.coreLoginInfo.systemSettings,
    systemLink: state.coreLoginInfo.systemLink,
    documentLink: state.coreLoginInfo.documentLink,
    sessionId: state.coreLoginInfo.sessionId,
    menuData: state.coreLoginInfo.menuData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  setHomeData: (fid, data) => dispatch(homeActions[TYPES.SET_HOME_DATA](fid, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(withCallAPI(withCodeUtil(SafetyInfoField)))));
